import { useMemo } from "react";
import { VaultPendingFilesActionButton, VaultPendingFilesActionButtonCheckmark, VaultPendingFilesActionButtonsGroup, VaultPendingFilesActionButtonTextSub, VaultPendingFilesActionButtonTextWrapper, VaultPendingFilesActionsWrapper, VaultPendingFilesActionTitleWrapper, VaultPendingFilesActionWrapper, VaultPendingFilesInfoWrapper, VaultPendingSingleFileDescription, VaultPendingSingleFileDescriptionEmpty } from "./VaultPendingFilesModal.styles";
import { AssistanceMessageAvatar } from "../../../assistance/components/Assistance.styles";
import { ChatAvatarIcon } from "../../../assistance/assets/icons";
import { AnimatedText } from "../../../user-activation-flow/components/ChatRow/AnimatedText";
import { VaultWhiteCheckmarkIcon } from "../../assets/icons";
import { useTextSwitcher } from "../../hooks/useTextSwitcher";
import { useSequentialAnimation } from "../../hooks/useSequentialAnimation";

export const VaultPendingFilesActions = (props) => {
    const {
        filesPending,
        assetsHandling,
        setAssetsHandling,
        showOptions
    } = props;

    const areFilesReady = ((filesPending.length > 0) && filesPending.every(file => file.llmStatus !== 'in process'));
    const isSingleFile = (filesPending.length === 1);

    const scanTexts = [
        `Scanning your file${isSingleFile ? '' : 's'}…`,
        "Analyzing its format...",
        "Identifying key content and insights..."
    ];

    const scanText = useTextSwitcher(scanTexts, 2000);
    const hasFilesInProcess = filesPending.some(file => file.llmStatus === 'in process');

    const animations = useMemo(() => [
        { text: isSingleFile ? (filesPending[0]?.llmResultMetadata?.description) : '', speed: 2000, bufferDelay: 500 },
        { duration: 1500, bufferDelay: 300 },
        { duration: 0 }
    ], [isSingleFile, filesPending]);

    const { isVisible } = useSequentialAnimation({
        isReady: areFilesReady,
        shouldReset: false,
        animations,
        skipFirst: !isSingleFile
    });

    const showActionTitle = isVisible(1);
    const showActionButtons = isVisible(2);

    const showSingleFileDescription = (isSingleFile && !hasFilesInProcess && filesPending[0].llmResultMetadata?.description);
    const showAvatar = (hasFilesInProcess || showSingleFileDescription);

    return (
        <VaultPendingFilesActionsWrapper>
            {
                showAvatar &&
                <AssistanceMessageAvatar>
                    <ChatAvatarIcon />
                </AssistanceMessageAvatar>
            }
            <VaultPendingFilesInfoWrapper>
                {
                    showSingleFileDescription &&
                    <VaultPendingSingleFileDescription>
                        <AnimatedText
                            delay={0}
                            animationSpeed={2000}
                            text={filesPending[0].llmResultMetadata?.description}
                        />
                    </VaultPendingSingleFileDescription>
                }
                {
                    hasFilesInProcess &&
                    <VaultPendingSingleFileDescriptionEmpty>
                        {scanText}
                    </VaultPendingSingleFileDescriptionEmpty>
                }
                {
                    areFilesReady &&
                    showActionTitle &&
                    <VaultPendingFilesActionWrapper>
                        <VaultPendingFilesActionTitleWrapper>
                            <AnimatedText
                                delay={0}
                                animationSpeed={1500}
                                text={showOptions ? `Everything’s set. What should we do with your file${isSingleFile ? '' : 's'}?` : `Everything’s set. Confirm the upload to proceed.`}
                                style={{
                                    color: '#1A1B1D',
                                    fontSize: '16px',
                                    fontStyle: 'normal',
                                    fontWeight: '700',
                                    lineHeight: '22px'
                                }}
                            />
                        </VaultPendingFilesActionTitleWrapper>
                        {
                            showOptions &&
                            showActionButtons &&
                            <VaultPendingFilesActionButtonsGroup>
                                <VaultPendingFilesActionButton>
                                    <VaultPendingFilesActionButtonCheckmark checked={true} disabled>
                                        <VaultWhiteCheckmarkIcon />
                                    </VaultPendingFilesActionButtonCheckmark>
                                    <VaultPendingFilesActionButtonTextWrapper>
                                        <strong>Store in Vault</strong>
                                        <VaultPendingFilesActionButtonTextSub>
                                            All uploaded files will be securely saved in your Vault.
                                        </VaultPendingFilesActionButtonTextSub>
                                    </VaultPendingFilesActionButtonTextWrapper>
                                </VaultPendingFilesActionButton>
                                <VaultPendingFilesActionButton onClick={() => setAssetsHandling({ ...assetsHandling, createNewAssets: !assetsHandling.createNewAssets })}>
                                    <VaultPendingFilesActionButtonCheckmark checked={assetsHandling.createNewAssets} >
                                        {assetsHandling.createNewAssets && <VaultWhiteCheckmarkIcon style={{ marginTop: '0.7359619140625px' }} />}
                                    </VaultPendingFilesActionButtonCheckmark>
                                    <VaultPendingFilesActionButtonTextWrapper>
                                        <span><strong>Create new</strong><span> assets</span></span>
                                    </VaultPendingFilesActionButtonTextWrapper>
                                </VaultPendingFilesActionButton>
                                <VaultPendingFilesActionButton onClick={() => setAssetsHandling({ ...assetsHandling, updateExistingAssets: !assetsHandling.updateExistingAssets })}>
                                    <VaultPendingFilesActionButtonCheckmark checked={assetsHandling.updateExistingAssets}>
                                        {assetsHandling.updateExistingAssets && <VaultWhiteCheckmarkIcon style={{ marginTop: '0.7359619140625px' }} />}
                                    </VaultPendingFilesActionButtonCheckmark>
                                    <VaultPendingFilesActionButtonTextWrapper>
                                        <span><strong>Update</strong><span> existing assets</span></span>
                                    </VaultPendingFilesActionButtonTextWrapper>
                                </VaultPendingFilesActionButton>
                            </VaultPendingFilesActionButtonsGroup>
                        }
                    </VaultPendingFilesActionWrapper>
                }
            </VaultPendingFilesInfoWrapper>
        </VaultPendingFilesActionsWrapper>
    )
};